import ReportRepository from "./../api"
import "./../types"

class ReportUseCase {
    constructor() {
        /** @type {ReportRepository}*/
        this.api = new ReportRepository()
    }

     /**
     *
     *  @param param {string}
     * @return {Promise<{data: Blob, err: null}|{data: null, err: ErrorState}>}
     */
      async exportReport(param) {
        const {data, err} = await this.api.exportReport(param)
        if (err && err === "record not found") {
            return {data: null, err: null}
        }
        
        return {data, err}
    }

    /**
     *
     *  @param param {string}
     * @return {Promise<{data: Array<Object>, err: null}|{data: null, err: ErrorState}>}
     */
     async getPerformance(param) {
        const {data, err} = await this.api.getPerformance(param)
        if (err && err === "record not found") {
            return {data: null, err: null}
        }
        return {data, err}
    }
}

export default new ReportUseCase()
